module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "fm_title"
  }, [_c('a', {
    attrs: {
      "id": "page_xvii"
    }
  }, [_c('span', {
    staticClass: "small"
  }, [_c('big', [_vm._v("A")]), _vm._v(" "), _c('big', [_vm._v("N")]), _vm._v("OTE ON "), _c('big', [_vm._v("D")]), _vm._v("ATES AND "), _c('big', [_vm._v("S")]), _vm._v("PELLING")], 1)])]), _c('a', {
    attrs: {
      "id": "page_xvii"
    }
  }, [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("Before 1918, the Julian Calendar (“Old Style”) was used in Russia and is still used by the Russian Orthodox Church. The Gregorian Calendar (“New Style”) was adopted in February 1918: this moved the calendar ahead by thirteen days, or twelve in the 19th century. Dates in this book are given in Old Style if the event took place in Russia before 1918, and in New Style if outside Russia or after 1918.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Except in the "), _c('span', {
    staticClass: "small"
  }, [_c('big', [_vm._v("B")]), _vm._v("IBLIOGRAPHY")], 1), _vm._v(", where authors and titles are transliterated according to the simplified Library of Congress system, Russian names are spelled in this book as we are used to seeing them, even if that entails some inconsistencies. For example, Tchaikovsky and Chekhov begin with the same Cyrillic letter, but I have retained the older spelling for Tchaikovsky’s name because it is more familiar than “Chaikovsky.” In cases of individual artists who adopted a non-standard spelling, I use that: Rachmaninoff (not Rakhmaninov), Chaliapin (not Shaliapin). Names of artists are spelled as they would be in a concert program or recording: Hvorostovsky (not Khvorostovski). In the narrative, first names common to both English and Russian are spelled as in English: Alexander, not Aleksandr; at the bottom of each song, however, where the author’s name is given, the full name is spelled in a more exact transliteration with stress marks: Aleksándr Sergéyevich Púshkin.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("To follow the words of a song as sung on recordings or in performance, a reader who does not already know Russian needs a phonetic transcription of the words rather than a transliteration. With each song, there is a phonetic transcription of the lyric in Latin letters, side by side with a translation into English. The purpose of these parallel texts is to enable readers who do not know Russian to follow the words, and what they mean, as they are being sung.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("My transcriptions are an attempt to show better than the LC system what the words actually sound like. In my transcription, the composer’s name would be spelled “Chajkófskij,” and the writer would be “Chékhaf.” Unlike transliteration, these spellings show the automatic changes that take place in voicing and devoicing of consonants, and in reduction of the vowel “o” to “a” when it is not stressed. They also show which syllable in the word is stressed, a feature that stands out very strongly in spoken Russian, less so when it is sung.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("First, and most important, is the sound “j” (called “yot” from Greek “iota”). It is exceedingly common in Russian. This is not “j” as in English or Spanish, but the sound “y” in “you,” “bayou,” or “boy.” When it begins a word, the reader should interpret the letter “j” in transcriptions of songs in this book as sounding like the German “Johann,” never like French Jean, Spanish Juan, or English John.")])]), _vm._m(0), _c('a', {
    attrs: {
      "id": "page_xviii"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("In words where spelling and speaking are at variance, the transcription shows the sound rather than the spelling for obvious reasons. There are few such cases in Russian, but they occur in some very common words and endings.")]), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The vowel system is very easy. The vowels are a, e, i, o, u, plus the deeper variant of “i” just mentioned. Every vowel is a syllable, and every syllable has one vowel in it. Russian words are stressed on one of the syllables only; unlike English, Russian does not have secondary stress. When a, e, and o are not in the stressed syllable, they are “reduced” in spoken Russian, but “o” to “a” is generally the only reduction heard in singing, and then not uniformly.")]), _vm._v(" "), _vm._m(2), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Consonants are transcribed as in the LC system except for “j.” My transcriptions do not show the difference between plain and palatalized consonants, but it is not necessary to understand the distinction in order to follow a song.")]), _vm._v(" "), _vm._m(3), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Some Russian consonants require two or more letters in transcription:")]), _vm._v(" "), _vm._m(4), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Some examples of Russian names follow in the table below:")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("1) The “LC” column shows Library of Congress transliteration, used in the "), _c('span', {
    staticClass: "small"
  }, [_c('big', [_vm._v("B")]), _vm._v("IBLIOGRAPHY")], 1), _vm._v(" of this book.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("2) The “Translation” column shows the spelling used in the narrative and commentary throughout the book.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("3) The “Song Text” column shows the transcription used in this book for each song, devised to approximate the way the words actually sound.")]), _vm._v(" "), _vm._m(5), _vm._v(" "), _vm._m(6)])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_xvii"
    }
  }), _c('a', {
    attrs: {
      "id": "page_xviii"
    }
  }, [_vm._v("I retain the LC convention of an apostrophe for the “soft sign” used in Russian spelling. Its use has nothing to do with the meaning of an apostrophe in English, but indicates that the letter it follows is “softened” or made with the palate (“palatalized”). When following words being sung, it may be ignored.")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "indent"
  }, [_vm._v("I have kept the LC convention of using “y” to stand for the tense Russian vowel that is a variant of “i” as in “Bill” or “wit,” only deeper. To master this sound, one needs to work with a Russian speaker. For an amusing illustration of the facial contortions required to pronounce this vowel in a loud voice from the rostrum of the Hall of Columns in Moscow, see the photograph of Nicolas Slonimsky in his autobiography "), _c('i', [_vm._v("Perfect Pitch")]), _vm._v(" ("), _c('i', [_vm._v("Slonimsky 1988")]), _vm._v(", plate 29).")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('table', {
    staticClass: "top",
    attrs: {
      "cellpadding": "0",
      "cellspacing": "0",
      "width": "90%"
    }
  }, [_c('colgroup', [_c('col', {
    attrs: {
      "width": "5%"
    }
  }), _vm._v(" "), _c('col', {
    attrs: {
      "width": "8%"
    }
  }), _vm._v(" "), _c('col', {
    attrs: {
      "width": "77%"
    }
  })]), _c('tbody', [_c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td'), _c('td', [_c('p', {
    staticClass: "tl"
  }, [_vm._v("a")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "tl"
  }, [_vm._v("as in “Mahler”")])])]), _vm._v(" "), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td'), _c('td', [_c('p', {
    staticClass: "tl"
  }, [_vm._v("e")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "tl"
  }, [_vm._v("as in “bet”")])])]), _vm._v(" "), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td'), _c('td', [_c('p', {
    staticClass: "tl"
  }, [_vm._v("i")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "tl"
  }, [_vm._v("as in “beet”")])])]), _vm._v(" "), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td'), _c('td', [_c('p', {
    staticClass: "tl"
  }, [_vm._v("y")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "tl"
  }, [_vm._v("as in “Bill” (tense “i” explained above)")])])]), _vm._v(" "), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td'), _c('td', [_c('p', {
    staticClass: "tl"
  }, [_vm._v("o")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "tl"
  }, [_vm._v("as in “coat” but deepened toward “call” (as in “kot,” tomcat)")])])]), _vm._v(" "), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td'), _c('td', [_c('p', {
    staticClass: "tl"
  }, [_vm._v("u")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "tl"
  }, [_vm._v("as in “flute”")])])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('table', {
    staticClass: "top",
    attrs: {
      "cellpadding": "0",
      "cellspacing": "0",
      "width": "90%"
    }
  }, [_c('colgroup', [_c('col', {
    attrs: {
      "width": "5%"
    }
  }), _vm._v(" "), _c('col', {
    attrs: {
      "width": "8%"
    }
  }), _vm._v(" "), _c('col', {
    attrs: {
      "width": "77%"
    }
  })]), _c('tbody', [_c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td'), _c('td', [_c('p', {
    staticClass: "tl"
  }, [_vm._v("b")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "tl"
  }, [_vm._v("as in “boy”")])])]), _vm._v(" "), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td'), _c('td', [_c('p', {
    staticClass: "tl"
  }, [_vm._v("d")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "tl"
  }, [_vm._v("as in “dish”")])])]), _vm._v(" "), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td'), _c('td', [_c('p', {
    staticClass: "tl"
  }, [_vm._v("f")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "tl"
  }, [_vm._v("as in “father”")])])]), _vm._v(" "), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td'), _c('td', [_c('p', {
    staticClass: "tl"
  }, [_vm._v("g")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "tl"
  }, [_vm._v("as in “Gogol”")])])]), _vm._v(" "), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td'), _c('td', [_c('p', {
    staticClass: "tl"
  }, [_vm._v("j")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "tl"
  }, [_vm._v("as in “Johann”")])])]), _vm._v(" "), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td'), _c('td', [_c('p', {
    staticClass: "tl"
  }, [_vm._v("k")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "tl"
  }, [_vm._v("as in “kaftan” (but without any puff of air)")])])]), _vm._v(" "), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td'), _c('td', [_c('p', {
    staticClass: "tl"
  }, [_vm._v("l")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "tl"
  }, [_vm._v("as in “bull”")])])]), _vm._v(" "), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td'), _c('td', [_c('p', {
    staticClass: "tl"
  }, [_vm._v("m")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "tl"
  }, [_vm._v("as in “Moscow”")])])]), _vm._v(" "), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td'), _c('td', [_c('p', {
    staticClass: "tl"
  }, [_vm._v("n")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "tl"
  }, [_vm._v("as in “noble”")])])]), _vm._v(" "), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td'), _c('td', [_c('p', {
    staticClass: "tl"
  }, [_vm._v("p")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "tl"
  }, [_vm._v("as in “Paul” (no puff of air)")])])]), _vm._v(" "), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td'), _c('td', [_c('p', {
    staticClass: "tl"
  }, [_c('a', {
    attrs: {
      "id": "page_xix"
    }
  }, [_vm._v("r")])])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "tl"
  }, [_vm._v("trilled once, as in Italian “Roma”")])])]), _vm._v(" "), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td'), _c('td', [_c('p', {
    staticClass: "tl"
  }, [_vm._v("s")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "tl"
  }, [_vm._v("as in “soul”")])])]), _vm._v(" "), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td'), _c('td', [_c('p', {
    staticClass: "tl"
  }, [_vm._v("t")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "tl"
  }, [_vm._v("as in “Tomsk” (no puff of air)")])])]), _vm._v(" "), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td'), _c('td', [_c('p', {
    staticClass: "tl"
  }, [_vm._v("v")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "tl"
  }, [_vm._v("as in “Volga”")])])]), _vm._v(" "), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td'), _c('td', [_c('p', {
    staticClass: "tl"
  }, [_vm._v("z")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "tl"
  }, [_vm._v("as in “Zachary”")])])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('table', {
    staticClass: "top",
    attrs: {
      "cellpadding": "0",
      "cellspacing": "0",
      "width": "90%"
    }
  }, [_c('colgroup', [_c('col', {
    attrs: {
      "width": "5%"
    }
  }), _vm._v(" "), _c('col', {
    attrs: {
      "width": "8%"
    }
  }), _vm._v(" "), _c('col', {
    attrs: {
      "width": "77%"
    }
  })]), _c('tbody', [_c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td'), _c('td', [_c('p', {
    staticClass: "tl"
  }, [_vm._v("ch")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "tl"
  }, [_vm._v("as in “China”")])])]), _vm._v(" "), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td'), _c('td', [_c('p', {
    staticClass: "tl"
  }, [_vm._v("kh")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "tl"
  }, [_vm._v("as in “Bach” or Scottish “loch”")])])]), _vm._v(" "), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td'), _c('td', [_c('p', {
    staticClass: "tl"
  }, [_vm._v("sh")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "tl"
  }, [_vm._v("as in “shoot”")])])]), _vm._v(" "), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td'), _c('td', [_c('p', {
    staticClass: "tl"
  }, [_vm._v("shch")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "tl"
  }, [_vm._v("as in “fresh chips”")])])]), _vm._v(" "), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td'), _c('td', [_c('p', {
    staticClass: "tl"
  }, [_vm._v("ts")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "tl"
  }, [_vm._v("as in “bats” or “pizza”")])])]), _vm._v(" "), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td'), _c('td', [_c('p', {
    staticClass: "tl"
  }, [_vm._v("zh")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "tl"
  }, [_vm._v("as in “azure” or French “Jean”")])])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "img",
      "src": "Images/p_xix.jpg"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "indent"
  }, [_vm._v("Readers who want to sing these songs will, I hope, understand that these transcriptions do not teach the pronunciation; but a course in Russian, even a short one, will. Singers without Russian who want to perform these songs should have the excellent "), _c('i', [_vm._v("Richter 2000")]), _vm._v(" in hand while working with a Russian coach.")])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-24de5fa4","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/009_Note.vue
// module id = 81
// module chunks = 0